import * as React from 'react';
import type { JSX } from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { IconPlaceholderBuilder24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BuilderCallReasonsRedesigned.css';

const QUESTIONS = [
  'Какие есть варианты отделки?',
  'Есть акции и скидки?',
  'Когда сдаётся дом?',
  'С каким банками работаете?',
  'Может, на других этажах есть квартиры дешевле?',
];

export interface IBuilderCallReasonsRedesignedProps {
  contactsButton: JSX.Element;
  callbackButton?: React.ReactNode;
  flatViewOrderButton?: React.ReactNode;
  isBuilder: boolean;
}

export const BuilderCallReasonsRedesigned: React.FC<IBuilderCallReasonsRedesignedProps> = ({
  contactsButton,
  callbackButton,
  flatViewOrderButton,
  isBuilder,
}) => {
  return (
    <div className={styles['builder-call-reasons']} data-testid="BuilderCallReasons">
      <div className={styles['content']}>
        <div className={styles['header']}>
          <div className={styles['icon']}>
            <IconPlaceholderBuilder24 color="icon-main-default" />
          </div>
          <UIHeading1>Спросите у {isBuilder ? 'застройщика' : 'продавца'}</UIHeading1>
        </div>
        <div className={styles['reasons']} data-testid="BuilderCallReasonList">
          {QUESTIONS.map((question, index) => (
            <div key={index} className={styles['reason']}>
              {question}
            </div>
          ))}
        </div>
        <div className={styles['actions']}>
          {contactsButton}
          {callbackButton}
          {flatViewOrderButton}
        </div>
      </div>
    </div>
  );
};
